import { UseMutationResult, useMutation } from '@tanstack/react-query';

import { getPrintLabel, PrintLabelResponse } from '../api/printLabel';

export const useGetPrintLabel = (entityId: number, entityType: string): UseMutationResult<PrintLabelResponse, Error, void> => {
  return useMutation({
    mutationFn: async () => {
      return await getPrintLabel(entityType, entityId);
    }
  });
};